import { BannersAction } from "Store/Banners/actions";

export interface IBanners {
  isFetching: boolean;
  isFetchFailed: boolean;
  content: Julius.Content.StartPage;
};

const initialBanners: IBanners = {
  isFetching: false,
  isFetchFailed: false,
  content: null,
};

function banners(
  state: IBanners = initialBanners, 
  action: BannersAction,
  ): IBanners {

  switch(action.type) {
    case 'SET_BANNERS_CONTENT':
      return {
        ...state,
        isFetching: false,
        isFetchFailed: false,
        content: action.banners ? action.banners : state.content,
      };
      
    case 'SET_IS_FETCHING_BANNERS':
      return {
        ...state,
        isFetching: true,
        isFetchFailed: false,
      };

    case 'SET_FETCH_BANNERS_FAILED':
      return {
        ...state,
        isFetching: false,
        isFetchFailed: true,
      };
    
    default:
      return state;
  }
}

export default banners;


// WEBPACK FOOTER //
// ./src/store/Banners/reducer.tsx